import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MailIcon, LockIcon, LogInIcon } from 'lucide-react';
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';
const Login: React.FC = () => {
  const [isLogin, setIsLogin] = useState(true);
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/jobs');
  };
  const handleGuestLogin = () => {
    navigate('/jobs');
  };
  return <div className="min-h-screen relative overflow-hidden" data-id="element-325">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0" data-id="element-326">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-gray-900 z-10" data-id="element-327"></div>
        <img src="https://images.unsplash.com/photo-1614728894747-a83421e2b9c9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80" alt="Mars surface" className="w-full h-full object-cover" data-id="element-328" />
      </div>
      <div className="relative z-10 flex flex-col min-h-screen justify-end" data-id="element-329">
        <div className="p-6 pt-10 pb-12 bg-white dark:bg-gray-900 rounded-t-3xl shadow-lg" data-id="element-330">
          <div className="text-center mb-8" data-id="element-331">
            <h1 className="text-4xl font-bold bg-gradient-to-r from-teal-500 to-cyan-400 bg-clip-text text-transparent" data-id="element-332">
              Dredget
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mt-2" data-id="element-333">
              Even on Mars, you can still find jobs.
            </p>
          </div>
          <div className="flex justify-center space-x-6 mb-6" data-id="element-334">
            <button className={`pb-2 px-2 font-medium ${isLogin ? 'text-teal-500 dark:text-teal-400 border-b-2 border-teal-500 dark:border-teal-400' : 'text-gray-500 dark:text-gray-400'}`} onClick={() => setIsLogin(true)} data-id="element-335">
              Login
            </button>
            <button className={`pb-2 px-2 font-medium ${!isLogin ? 'text-teal-500 dark:text-teal-400 border-b-2 border-teal-500 dark:border-teal-400' : 'text-gray-500 dark:text-gray-400'}`} onClick={() => setIsLogin(false)} data-id="element-336">
              Sign Up
            </button>
          </div>
          <form onSubmit={handleSubmit} data-id="element-337">
            <Input type="email" label="Email" placeholder="Enter your email" icon={<MailIcon size={18} data-id="element-339" />} fullWidth required data-id="element-338" />
            <Input type="password" label="Password" placeholder="Enter your password" icon={<LockIcon size={18} data-id="element-341" />} fullWidth required data-id="element-340" />
            {!isLogin && <Input type="password" label="Confirm Password" placeholder="Confirm your password" icon={<LockIcon size={18} data-id="element-343" />} fullWidth required data-id="element-342" />}
            {isLogin && <div className="text-right mb-4" data-id="element-344">
                <a href="#" className="text-sm text-teal-500 dark:text-teal-400 hover:underline" data-id="element-345">
                  Forgot password?
                </a>
              </div>}
            <Button variant="primary" fullWidth size="lg" type="submit" icon={<LogInIcon size={20} data-id="element-347" />} data-id="element-346">
              {isLogin ? 'Login' : 'Sign Up'}
            </Button>
          </form>
          <div className="mt-6 flex items-center" data-id="element-348">
            <div className="flex-1 border-t border-gray-300 dark:border-gray-700" data-id="element-349"></div>
            <span className="mx-4 text-sm text-gray-500 dark:text-gray-400" data-id="element-350">
              or
            </span>
            <div className="flex-1 border-t border-gray-300 dark:border-gray-700" data-id="element-351"></div>
          </div>
          <div className="mt-6 space-y-3" data-id="element-352">
            <button className="w-full py-2.5 px-4 border border-gray-300 dark:border-gray-700 rounded-xl flex justify-center items-center space-x-2 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors" data-id="element-353">
              <img src="https://www.google.com/favicon.ico" alt="Google" className="w-5 h-5" data-id="element-354" />
              <span className="text-gray-700 dark:text-gray-300" data-id="element-355">
                Continue with Google
              </span>
            </button>
            <button className="w-full py-2.5 px-4 border border-gray-300 dark:border-gray-700 rounded-xl flex justify-center items-center space-x-2 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors" data-id="element-356">
              <img src="https://www.linkedin.com/favicon.ico" alt="LinkedIn" className="w-5 h-5" data-id="element-357" />
              <span className="text-gray-700 dark:text-gray-300" data-id="element-358">
                Continue with LinkedIn
              </span>
            </button>
          </div>
          <div className="mt-6 text-center" data-id="element-359">
            <button onClick={handleGuestLogin} className="text-teal-500 dark:text-teal-400 hover:underline" data-id="element-360">
              Continue as Guest
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default Login;